// extracted by mini-css-extract-plugin
export default {"container":"About_container__r9A2e","text":"About_text__OkYP5","image":"About_image__h3z0n","image2":"About_image2__iDcGP"};